import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { request } from "@/js/http/http_request";
import { isProfessional, isWholesaler, isHolding } from "@/js/http/auth";
import * as orderHandler from "@/js/order/order.js";
import { orderStatus, expeditionMethods, listTerms } from "@/js/lists.ts";
import creditCardComponent from "@/components/stripe/CreditCardComponent.vue";
import bankAccountComponent from "@/components/stripe/BankAccountComponent.vue";
import returnComponent from "@/components/navigation/ReturnToList.vue";
import PaymentGoBackDialog from "@/components/payment/PaymentGoBackDialog.vue";
import PaymentMicroDepositsDialog from "./PaymentMicroDepositsDialog.vue";
import { getSymbolCurrency, formatPrice } from "@/js/currency/currencies.js";
import { getFullNameUser } from "@/js/user/user.js";
import WholesalersData from "@/components/payment/WholesalersData.vue";
export default {
  name: "PaymentComponent",
  data: function data() {
    return {
      ach: null,
      dontSavePayment: false,
      customerId: null,
      isValidSepa: false,
      achErrorOccurred: false,
      microDepositsUrl: null,
      paymentMicroDepositsShown: false,
      isConnectingAch: false,
      creditCard: null,
      paymentGoBackDialogShown: false,
      paymentGoBackDialogTitle: "Some products are unavailable!",
      paymentGoBackDialogText: "Some of your products have just become unavailable, go back to the order details to see which ones are impacted.",
      returnRoute: "",
      returnParams: {},
      stripeErrorOccured: false,
      user: {},
      isLoadingStripe: true,
      isLoadingRequirements: true,
      setupIntent: {},
      order: {
        id_order: null,
        items: [],
        id_user: null,
        amount_ex_vat: null,
        total_amount: null,
        status: null,
        expedition_method: 0,
        delivery_address: null,
        billing_address: null,
        reference_order: null,
        amount_taxes: null,
        amount_shipping: null,
        payment_method_id: "",
        due_date: null,
        buyer_term: 0,
        cancellation_date: null,
        deleted: false
      },
      orderValidated: false,
      payment_method_id: null,
      payment_method: null,
      bankAccount: null,
      usBankAccount: null,
      stripe: "",
      list_bank_accounts: [],
      list_us_bank_accounts: [],
      list_credit_cards: [],
      client_secret: "",
      listCountries: [],
      listStates: [],
      payment: {
        methodId: null,
        microDepositsUrl: null,
        currency: null,
        amount: 0.0
      },
      expedition_methods: expeditionMethods,
      orderStatus: orderStatus
    };
  },
  computed: {
    isHoreca: function isHoreca() {
      return isProfessional(this.loggedUserData) || isWholesaler(this.loggedUserData) || isHolding(this.loggedUserData);
    },
    isHorecaUs: function isHorecaUs() {
      return this.isHoreca && this.order.delivery_address.country.iso_code === "USA";
    },
    isCreditCardsForbidden: function isCreditCardsForbidden() {
      var _this$order$delivery_;
      return (isProfessional(this.loggedUserData) || isWholesaler(this.loggedUserData)) && this.order.delivery_address.country.iso_code === "USA" && ["NY", "NJ"].includes((_this$order$delivery_ = this.order.delivery_address) === null || _this$order$delivery_ === void 0 || (_this$order$delivery_ = _this$order$delivery_.state) === null || _this$order$delivery_ === void 0 ? void 0 : _this$order$delivery_.iso_state);
    },
    messagePaymentDate: function messagePaymentDate() {
      var _this2 = this;
      if (this.isHorecaUs) {
        if (this.order.buyer_term > 1) return "Your bank account will be debited " + listTerms.find(function (x) {
          return x.id === _this2.order.buyer_term;
        }).name + " upon delivery.";else return "Your bank account will be debited at the time of the order delivery.";
      } else if (this.isHoreca) {
        if (this.order.buyer_term > 1) return "Your bank account will be debited " + listTerms.find(function (x) {
          return x.id === _this2.order.buyer_term;
        }).name + " upon shipment.";else return "Your bank account will be debited at the time of the order shipment.";
      } else {
        return "Your bank account will be debited at the time of the order approvement.";
      }
    },
    isLoading: function isLoading() {
      return this.isLoadingRequirements || this.isLoadingStripe;
    },
    isAbleToPay: function isAbleToPay() {
      var _this$creditCard, _this$bankAccount;
      var hasCreditCard = ((_this$creditCard = this.creditCard) === null || _this$creditCard === void 0 ? void 0 : _this$creditCard.selected) || this.creditCard === 0;
      var hasUsBankAccount = !!this.usBankAccount || this.usBankAccount === 0 && this.setupIntent.status === "succeeded";
      var hasBankAccount = !!((_this$bankAccount = this.bankAccount) !== null && _this$bankAccount !== void 0 && _this$bankAccount.id_stripe_bank_account) || this.bankAccount === 0 && this.isValidSepa;
      var isBrazilCardInvalid = this.payment_method == "cc" && this.creditCard && this.creditCard === -1;
      if (isBrazilCardInvalid) {
        return false;
      }
      return !this.isLoading && !this.stripeErrorOccured && (this.payment_method == "cc" && hasCreditCard || this.payment_method == "ba" && hasBankAccount || this.payment_method === "ach" && hasUsBankAccount);
    }
  },
  created: function created() {
    if (this.$route.params.orderValidated) {
      this.orderValidated = this.$route.params.orderValidated;
      this.$EventBus.$emit("ItemRemoved", {
        detail: {
          items: []
        }
      });
    }
    this.order = orderHandler.getCurrentPayment();
    if (this.order) {
      if (this.order.status == 1) {
        this.returnRoute = "finalizeCart";
        this.returnParams = {};
      } else {
        this.returnRoute = "userOrderSummary";
        this.returnParams = {
          id: this.order.id_order
        };
      }
      if (this.loggedUserData.userGroup == "USER" || this.order.currency !== "EUR") {
        this.payment_method = "cc";
      }
    }
    var _this = this;
    this.includeStripe("js.stripe.com/v3/", function () {
      this.configureStripe();
    }.bind(this));
    Promise.all([request("/v1/stripe/orders/".concat(_this.order.id_order, "/setup-intent"), "get", null, true, "api").then(function (response) {
      _this.customerId = response.data.customer;
      _this.client_secret = response.data.client_secret;
    }), request("/v1/stripe/orders/".concat(_this.order.id_order, "/payment-methods"), "get", null, true, "api").then(function (response) {
      _this.list_bank_accounts = _toConsumableArray(response.data.list_bank_accounts);
      _this.list_credit_cards = _toConsumableArray(response.data.list_credit_cards);
      _this.list_us_bank_accounts = _toConsumableArray(response.data.list_us_bank_accounts);
      _this.usBankAccount = _this.list_us_bank_accounts.length && 0;
    }), request("/v1/user", "get", null, true, "api").then(function (response) {
      _this.user = _objectSpread({}, response.data);
    })]).then(function () {
      _this.isLoadingRequirements = false;
    });
  },
  components: {
    CreditCardForm: creditCardComponent,
    PaymentMicroDepositsDialog: PaymentMicroDepositsDialog,
    SepaBankAccount: bankAccountComponent,
    return: returnComponent,
    PaymentGoBackDialog: PaymentGoBackDialog,
    WholesalersData: WholesalersData
  },
  props: ["loggedUserData"],
  methods: {
    continuePaymentFromDeposits: function continuePaymentFromDeposits(callback) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this3.confirmPayment();
            case 2:
              callback();
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    confirmSepaBankAccount: function confirmSepaBankAccount(value) {
      this.isValidSepa = value;
    },
    connectAch: function connectAch() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this4.isConnectingAch = true;
              _this = _this4;
              _this4.stripe.collectBankAccountForSetup({
                clientSecret: _this4.client_secret,
                params: {
                  payment_method_type: "us_bank_account",
                  payment_method_data: {
                    billing_details: {
                      name: getFullNameUser(_this4.user),
                      email: _this4.user.login
                    }
                  }
                },
                expand: ["payment_method"]
              }).then(function (_ref) {
                var setupIntent = _ref.setupIntent,
                  error = _ref.error;
                if (error) {
                  _this.isConnectingAch = false;
                } else if (setupIntent.status === "requires_payment_method") {
                  _this.isConnectingAch = false;
                } else if (setupIntent.status === "requires_confirmation") {
                  _this.stripe.confirmUsBankAccountSetup(_this.client_secret).then(/*#__PURE__*/function () {
                    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_ref2) {
                      var _setupIntent$next_act;
                      var setupIntent, error;
                      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                        while (1) switch (_context2.prev = _context2.next) {
                          case 0:
                            setupIntent = _ref2.setupIntent, error = _ref2.error;
                            if (error || setupIntent.status === "requires_payment_method") {
                              _this.stripeErrorOccured = true;
                              _this.achErrorOccurred = true;
                            } else if (setupIntent.status === "succeeded" || setupIntent.status === "processing") {
                              _this.stripeErrorOccured = false;
                              _this.setupIntent = setupIntent;
                              _this.usBankAccount = 0;
                            } else if (((_setupIntent$next_act = setupIntent.next_action) === null || _setupIntent$next_act === void 0 ? void 0 : _setupIntent$next_act.type) === "verify_with_microdeposits") {
                              _this.microDepositsUrl = setupIntent.next_action.verify_with_microdeposits.hosted_verification_url;
                              //_this.order.microDepositsUrl = _this.microDepositsUrl
                              _this.payment.microDepositsUrl = _this.microDepositsUrl;
                              _this.setupIntent = setupIntent;
                              _this.paymentMicroDepositsShown = true;
                            }
                            _this.isConnectingAch = false;
                          case 3:
                          case "end":
                            return _context2.stop();
                        }
                      }, _callee2);
                    }));
                    return function (_x) {
                      return _ref3.apply(this, arguments);
                    };
                  }()).catch(function (message) {
                    _this.$EventBus.$emit("loading", false);
                    _this.$toasted.show(message, {
                      type: "warning"
                    });
                  });
                }
              });
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    switchCard: function switchCard() {
      this.stripeErrorOccured = false;
      this.includeStripe("js.stripe.com/v3/", function () {
        this.configureStripe();
      }.bind(this));
    },
    confirmPayment: function confirmPayment() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this5.$EventBus.$emit("loading", true);
              _this = _this5;
              if (!(_this5.payment_method == "cc")) {
                _context4.next = 6;
                break;
              }
              if (_this5.creditCard === 0) {
                _this5.$refs.creditCard.saveCard().then(function (payment_method_id) {
                  _this.stripeErrorOccured = false;
                  _this.savePaymentMethodToOrder(payment_method_id);
                }).catch(function () {
                  _this.stripeErrorOccured = true;
                  _this.$EventBus.$emit("loading", false);
                });
              } else {
                _this5.savePaymentMethodToOrder(_this5.creditCard.payment_method_id, _this5.creditCard.user.id_user);
              }
              _context4.next = 20;
              break;
            case 6:
              if (!(_this5.payment_method == "ba")) {
                _context4.next = 10;
                break;
              }
              if (_this5.bankAccount === 0) {
                _this5.$refs.bankAccount.saveBankAccount().then(function (payment_method_id) {
                  _this.stripeErrorOccured = false;
                  _this.savePaymentMethodToOrder(payment_method_id);
                }).catch(function (e) {
                  _this.stripeErrorOccured = true;
                  _this.$EventBus.$emit("loading", false);
                });
              } else {
                _this5.savePaymentMethodToOrder(_this5.bankAccount.payment_method_id, _this5.bankAccount.user.id_user);
              }
              _context4.next = 20;
              break;
            case 10:
              if (!(_this5.payment_method == "ach")) {
                _context4.next = 20;
                break;
              }
              if (!(_this5.usBankAccount === 0)) {
                _context4.next = 19;
                break;
              }
              _this5.stripeErrorOccured = false;
              if (_this5.dontSavePayment) {
                _context4.next = 16;
                break;
              }
              _context4.next = 16;
              return request("/v1/stripe/payment-method", "post", {
                customerId: _this5.customerId,
                orderId: _this5.order.id_order,
                payment_method_id: _this5.setupIntent.payment_method
              }, true, "api");
            case 16:
              _this5.savePaymentMethodToOrder(_this5.setupIntent.payment_method);
              _context4.next = 20;
              break;
            case 19:
              _this5.savePaymentMethodToOrder(_this5.usBankAccount.payment_method_id, _this5.usBankAccount.user.id_user);
            case 20:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    savePaymentMethodToOrder: function savePaymentMethodToOrder(payment_method_id) {
      var user_id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      this.payment.methodId = payment_method_id;
      this.payment.orderId = this.order.id_order;
      this.payment.currency = this.order.currency;
      this.payment.amount = this.order.total_amount_currency_include_credit_notes;
      if (user_id) {
        this.payment.userId = user_id;
      }
      var status = orderStatus.filter(function (os) {
        return os.id === "AWAITING_VALIDATION";
      })[0].status;
      var _this = this;
      return request("/v1/payment", "post", this.payment, true, "api", null).then(function () {
        if (_this.order.status !== orderStatus.find(function (os) {
          return os.id === "CREATED";
        }).status && _this.order.status !== orderStatus.find(function (os) {
          return os.id === "AWAITING_CUSTOMER_VALIDATION";
        }).status) {
          _this.$toasted.show("Payment saved.", {
            type: "success"
          });
          orderHandler.removePaymentFromStorage();
          _this.$EventBus.$emit("loading", false);
          _this.$router.push({
            name: "userOrderSummary",
            params: {
              id: _this.order.id_order
            }
          });
        } else {
          request("/v1/order/" + _this.order.id_order + "/state/" + status, "put", {
            send_mails: true
          }, true, "api").then(function () {
            _this.validatePayment();
          }).catch(function (e) {
            _this.$toasted.show("An error occured. Please contact an administrator.", {
              type: "error"
            });
            _this.$EventBus.$emit("loading", false);
          });
        }
      }).catch(function (e) {
        _this.$toasted.show("An error occured. Please contact an administrator.", {
          type: "error"
        });
        _this.$EventBus.$emit("loading", false);
      });
    },
    validatePayment: function validatePayment() {
      var _this6 = this;
      this.$toasted.show("Payment saved.", {
        type: "success"
      });
      var allowedStatus = orderStatus.filter(function (x) {
        return x.id === "CREATED" || x.id === "AWAITING_CUSTOMER_VALIDATION";
      });
      if (allowedStatus.some(function (x) {
        return x.status === _this6.order.status;
      })) {
        var orderStorage = orderHandler.getCurrentOrder();
        if (orderStorage && orderStorage.id_order == this.order.id_order) {
          if (this.order.status == orderStatus.find(function (x) {
            return x.id == "CREATED";
          }).status) {
            orderHandler.removeOrderFromStorage();
          }
          this.$EventBus.$emit("order-made");
          this.$EventBus.$emit("ItemRemoved", {
            detail: {
              items: []
            }
          });
          this.$EventBus.$emit("BasketRemoved");
        }
      }
      orderHandler.removePaymentFromStorage();
      this.orderValidated = true;
      this.returnRoute = "userHome";
      this.$EventBus.$emit("loading", false);
    },
    //FOR STRIPE
    includeStripe: function includeStripe(URL, callback) {
      var documentTag = document,
        tag = "script",
        object = documentTag.createElement(tag),
        scriptTag = documentTag.getElementsByTagName(tag)[0];
      object.src = "//" + URL;
      if (callback) {
        object.addEventListener("load", function (e) {
          callback(null, e);
        }, false);
      }
      scriptTag.parentNode.insertBefore(object, scriptTag);
    },
    configureStripe: function configureStripe() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var response;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this7.isLoadingStripe = true;
              if (!_this7.order) {
                _context5.next = 6;
                break;
              }
              _context5.next = 4;
              return request("/v1/stripe/orders/".concat(_this7.order.id_order, "/publishable-key"), "get", null, true, "api");
            case 4:
              response = _context5.sent;
              _this7.stripe = Stripe(response.data.value);
            case 6:
              _this7.isLoadingStripe = false;
            case 7:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    goHome: function goHome() {
      this.$router.push({
        name: "userHome"
      });
    },
    getSymbolCurrency: getSymbolCurrency,
    formatPrice: formatPrice
  }
};